import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Silence the harmless "ResizeObserver loop completed" overlay from Radix UI.
// (CRA's iframe error overlay listens to window 'error' events.)
const RESIZE_OBSERVER_ERR = /ResizeObserver loop/;
window.addEventListener('error', (e) => {
  if (e?.message && RESIZE_OBSERVER_ERR.test(e.message)) {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
